interface Props {
  submitted: boolean;
  onStart: () => void;
}

export function InsuranceCardPrompt({ submitted, onStart }: Props) {
  if (submitted) {
    return (
      <div className="status-alert status-alert--success">
        <p className="status-headline">Insurance card received.</p>
        <p>Thank you.</p>
      </div>
    );
  }

  return (
    <div className="status-alert status-alert--info insurance-prompt">
      <p className="status-headline">While you wait, upload your insurance card</p>
      <p>It takes about a minute and saves time for your nurse.</p>
      <button type="button" className="btn btn-primary" onClick={onStart}>
        Upload insurance card
      </button>
    </div>
  );
}
